import { render, staticRenderFns } from "./buttons-hamburger.vue?vue&type=template&id=1852166a&scoped=true"
import script from "./buttons-hamburger.vue?vue&type=script&lang=js"
export * from "./buttons-hamburger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1852166a",
  null
  
)

export default component.exports